<template>
    <section class="client-summary">
        <button class="client-summary__card client-summary__card--action" type="button" @click="$emit('view-history')">
            <span class="client-summary__kicker">History</span>
            <span class="client-summary__title">View past responses</span>
        </button>

        <div class="client-summary__card">
            <span class="client-summary__kicker">Sessions logged</span>
            <span class="client-summary__value">{{ totalSessions }}</span>
        </div>

        <div class="client-summary__card" :class="{ 'client-summary__card--overdue': daysSinceLastReport > 90 }">
            <span class="client-summary__kicker">Days since last form</span>
            <span class="client-summary__value">{{ daysSinceLastReport }}</span>
        </div>
    </section>
</template>

<script>
export default {
    name: 'DashboardClientSummary',

    props: {
        totalSessions: {
            type: Number,
            default: 0
        },
        daysSinceLastReport: {
            type: Number,
            default: 0
        }
    },

    emits: ['view-history']
}
</script>

<style scoped>
.client-summary {
    display: grid;
    grid-template-columns: repeat(3, minmax(0, 1fr));
    gap: 16px;
    padding: 20px;
    background: white;
    border-bottom: 1px solid rgba(47, 62, 70, 0.08);
}

.client-summary__card {
    display: flex;
    flex-direction: column;
    justify-content: space-between;
    min-height: 82px;
    padding: 16px;
    border: 0;
    border-radius: 12px;
    background:
        linear-gradient(160deg, rgba(132, 169, 140, 0.08), rgba(255, 255, 255, 0.96));
    box-shadow: 0 8px 25px rgba(47, 62, 70, 0.08);
    text-align: left;
}

.client-summary__card--overdue {
    background:
        linear-gradient(160deg, rgba(244, 190, 104, 0.14), rgba(255, 255, 255, 0.96));
}

.client-summary__kicker {
    font-size: 12px;
    font-weight: 600;
    letter-spacing: 0.5px;
    text-transform: uppercase;
    color: #2f3e46;
}

.client-summary__title {
    margin-top: 8px;
    font-size: 1.1rem;
    font-weight: 600;
    color: #25434a;
}

.client-summary__meta {
    margin-top: 6px;
    color: #607175;
    line-height: 1.4;
    font-size: 14px;
}

.client-summary__value {
    margin-top: 12px;
    font-size: 1.8rem;
    font-weight: 600;
    line-height: 1;
    color: #25434a;
}

@media (max-width: 900px) {
    .client-summary {
        grid-template-columns: 1fr;
    }
}

@media (max-width: 700px) {
    .client-summary {
        padding: 16px 12px;
    }
}
</style>
